import React, { useEffect, useState } from 'react';

import { IKogModalProps } from '@/main/@types/interfaceIcons';
import { quoteItemCommentApi } from '@/main/api';
import KogModalSideComponent from '@/main/components/modal/ModalSide';
import { ClaimGridItemPartResponse, QuoteItemCommentHeaderResponse, QuoteItemCommentResponse } from '@/main/models/response';
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';

import FooterComment from './footerComment/footerComment';
import GridComments from './gridComments/gridComments';
import HeaderModaComment from './headerModaComment/headerModaComment';
import * as S from './styles';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import { IIconChatSearchClaimProps } from '../iconChatSearchClaim';

interface IModalSearchClaimCommentProps extends IIconChatSearchClaimProps, IKogModalProps { }

function ModalSearchClaimComment({
  isOpenModal,
  guidQuoteItem,
  setIsOpenModal,
  updateGridPartByGuidQuoteItem,
  closeModal,
}: IModalSearchClaimCommentProps) {
  const [dataHeader, setDataHeader] = useState<QuoteItemCommentHeaderResponse | null>(null);
  const [guidReplyComment, setGuidReplyComment] = useState<string>('');
  const [comments, setComments] = useState<QuoteItemCommentResponse[]>([])
  const [isLoadingComments, setIsLoadingComments] = useState<boolean>(false)
  const [isLoadingHeader, setIsLoadingHeader] = useState<boolean>(false)

  async function loadHeaderComments() {
    setIsLoadingHeader(true);

    quoteItemCommentApi
      .getCommentsHeaderByQuoteItem(guidQuoteItem)
      .then(response => {
        const { result } = response.data;
        if (!result) return
        setDataHeader(result)
      })
      .finally(() => setIsLoadingHeader(false));
  }
  async function loadComments() {
    setIsLoadingComments(true);

    quoteItemCommentApi
      .getCommentsByQuoteItem(guidQuoteItem)
      .then(response => {
        const { result } = response.data;
        if (isNullUndefined(result)) return
        setComments(result);

        if (result.length === 0) return;
        const lastComment = result[result.length - 1].text;

        const objUpdate: Partial<ClaimGridItemPartResponse> = {
          commentsCount: result.length,
          lastComment: lastComment
        };
        updateGridPartByGuidQuoteItem(guidQuoteItem, objUpdate);
      })
      .finally(() => setIsLoadingComments(false));
  };

  function replyComment(id: string) {
    setGuidReplyComment(id);
  }

  function removeReply() {
    setGuidReplyComment('');
  }

  useEffect(() => {
    if (isOpenModal) {
      loadHeaderComments();
      loadComments();
    }
  }, [isOpenModal]);


  if (isLoadingHeader && isLoadingComments) return <LoadingComponent />;
  const findMessageReply = comments.find(comment => comment.guidQuoteItemComment === guidReplyComment);

  return (
    <S.Container>
      <S.ContainerBaseModalComment>
        <S.TitleModal>{getTranslateByKey('information.comments')}</S.TitleModal>
      </S.ContainerBaseModalComment>
      <HeaderModaComment
        dataHeader={dataHeader}
        isLoadingHeader={isLoadingHeader}
      />
      <GridComments
        comments={comments}
        isLoadingComments={isLoadingComments}
        replyComment={replyComment}
      />
      <FooterComment
        dataHeader={dataHeader}
        guidQuoteItem={guidQuoteItem}
        loadComments={loadComments}
        messageReply={findMessageReply}
        removeReply={removeReply}
      />

    </S.Container>
  )
}


function WrapperModalSearchClaimComment(props: IModalSearchClaimCommentProps) {
  return (
    <KogModalSideComponent
      open={props.isOpenModal}
      padding='0'
      closeModal={() => props.setIsOpenModal(false)}
    >
      {props.isOpenModal && (
        <ModalSearchClaimComment {...props} />
      )}
    </KogModalSideComponent>
  )
}

export default WrapperModalSearchClaimComment